import React, { useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Avatar,
} from "@mui/material";

const TestimonialSection = ({ testimonials }) => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleCard = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <Box sx={{ width: "80%", mx: "auto", mt: 10 }}>
      <Typography
        variant="h4"
        align="left"
        sx={{
          mb: 4,
          fontFamily: "Aclonica",
        }}
        className="hero-text"
      >
        Hear it from our Students
      </Typography>

      <Grid container spacing={4}>
        {testimonials.map((testimonial, index) => {
          const isExpanded = expandedIndex === index;
          return (
            <Grid item xs={12} sm={6} key={index}>
              <Card
                sx={{
                  height: isExpanded ? "auto" : 228,
                  overflow: "hidden",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  boxShadow: isExpanded ? 6 : 2,
                  borderRadius: 3,
                }}
                onClick={() => toggleCard(index)}
              >
                <Box sx={{ display: "flex", alignItems: "center", p: 2 }}>
                  <Avatar
                    src={testimonial.image}
                    alt={testimonial.name}
                    sx={{ width: 80, height: 80, mr: 2 }}
                  />
                  <Box>
                    <Typography variant="h6" sx={{ fontFamily: "Aclonica" }}>
                      {testimonial.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {testimonial.class !== "" && "Class - "}
                      {testimonial.class}
                      {testimonial.class !== "" && "  |  "} City -{" "}
                      {testimonial.city}
                    </Typography>
                  </Box>
                </Box>

                <CardContent sx={{ pt: 0 }}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#555",
                      transition: "all 0.3s ease",
                      display: "-webkit-box",
                      WebkitLineClamp: isExpanded ? "none" : 3,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {testimonial.content}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default TestimonialSection;
